import { useInteractionContext } from '@components/ElementAnalytics/InteractionContext';
import {
  Box,
  FormControl,
  FormLabel,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import React from 'react';

export const CHALKTALK = 'chalktalk';
export const MY_QUESTIONS = 'my-questions';
export const DISTRICT = 'district';

interface ItemBankToggleButtonGroupProps {
  setItemBankKey: (key: string) => void;
}

const ItemBankToggleButtonGroup: React.FC<ItemBankToggleButtonGroupProps> = ({
  setItemBankKey,
}) => {
  const [itemBank, setItemBank] = React.useState(CHALKTALK);
  const { getTestId } = useInteractionContext();
  const handleChange = (event: React.MouseEvent<HTMLElement>, value: string) => {
    if (value === null) {
      return;
    }
    setItemBank(value);
    setItemBankKey(value);
  };
  return (
    <Box data-testid={getTestId('item-bank-toggle-button-group-wrapper')}>
      <ToggleButtonGroup
        color="primary"
        value={itemBank}
        exclusive
        onChange={handleChange}
        aria-label="Platform"
        size="small"
        sx={{
          height: '2.5rem',
        }}
        data-testid={getTestId('item-bank-toggle-button-group')}
      >
        <ToggleButton value={CHALKTALK} title="Questions created by Chalktalk">
          Chalktalk
        </ToggleButton>
        <ToggleButton value={DISTRICT} title="Questions created by your District">
          District
        </ToggleButton>
        <ToggleButton
          value={MY_QUESTIONS}
          title="Questions created by you"
          sx={{ minWidth: '5rem' }}
        >
          My
        </ToggleButton>
      </ToggleButtonGroup>
      <FormControl sx={{ mt: 1.5, ml: '0.5rem' }}>
        <FormLabel id="item-bank-label">Questions</FormLabel>
      </FormControl>
    </Box>
  );
};

export default ItemBankToggleButtonGroup;
